<template>
  <div style="background-color: #F4F7FE; min-height: 100vh;" class="pa-6">
    <v-row class="mb-4" align="center">
      <v-col cols="12" md="6">
        <h2 class="text-h4 font-weight-black" style="color: #1B2559;">Registro de Visitas</h2>
        <div class="d-flex align-center mt-1">
          <v-icon small color="#A3AED0" class="mr-2">mdi-account-clock</v-icon>
          <span class="text-subtitle-2 font-weight-bold" style="color: #A3AED0;">
            Control de afluencia diaria - LIVE FIT
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-md-end">
        <periodo-busqueda @buscar="onBuscar" />
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col cols="12" md="4">
        <v-card class="rounded-xl pa-6 elevation-1" color="#4318FF" dark>
          <div class="d-flex align-center">
            <v-btn fab color="rgba(255,255,255,0.2)" depressed class="mr-4">
              <v-icon large>mdi-account-group</v-icon>
            </v-btn>
            <div>
              <div class="text-overline white--text" style="opacity: 0.8">Visitas en Periodo</div>
              <div class="text-h4 font-weight-black">{{ visitas.length }}</div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card class="rounded-xl pa-6 elevation-1 d-flex align-center justify-space-around" height="100%">
          <div v-for="(m, i) in totalesMembresias.slice(0, 3)" :key="i" class="text-center">
            <div class="caption grey--text font-weight-black text-uppercase">{{ m.nombre }}</div>
            <div class="text-h6 font-weight-black" style="color: #1B2559;">{{ m.total }} Asistencias</div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="rounded-xl elevation-1 border-0 pa-4 mb-8">
      <v-card-title>
        <span class="text-h6 font-weight-bold" style="color: #1B2559;">Historial de Accesos</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          append-icon="mdi-magnify"
          label="Buscar por miembro..."
          solo-inverted flat hide-details
          class="rounded-lg" style="max-width: 350px"
        ></v-text-field>
      </v-card-title>

      <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :items="visitas"
        :search="busqueda"
        class="mt-4"
        :footer-props="{itemsPerPageText: 'Filas por página'}"
      >
        <template v-slot:[`item.imagen`]="{ item }">
          <v-avatar size="36">
            <img :src="urlImagen(item.imagen) ">
          </v-avatar>
        </template>

        <template v-slot:[`item.membresia`]="{ item }">
          <v-chip small :color="item.membresia.includes('REGULAR') ? '#A3AED0' : '#4318FF'" dark class="font-weight-bold">
            {{ item.membresia }}
          </v-chip>
        </template>
        
        <template v-slot:[`item.fecha`]="{ item }">
          <span class="font-weight-medium" style="color: #1B2559;">{{ item.fecha }}</span>
        </template>
      </v-data-table>
    </v-card>

    <v-row>
      <v-col cols="12" md="6">
        <div class="d-flex align-center mb-4">
          <v-icon color="#1B2559" class="mr-2">mdi-badge-account</v-icon>
          <h3 class="text-h5 font-weight-black" style="color: #1B2559;">Check-ins por Recepcionista</h3>
        </div>
        <v-row>
          <v-col v-for="(u, idx) in totalesUsuarios" :key="idx" cols="12" sm="6">
            <v-card class="rounded-xl pa-4 elevation-1 d-flex align-center">
              <v-avatar color="#F4F7FE" size="40" class="mr-3">
                <v-icon color="#4318FF">mdi-account-cash</v-icon>
              </v-avatar>
              <div>
                <div class="caption grey--text font-weight-bold">{{ u.nombre }}</div>
                <div class="text-h6 font-weight-black">{{ u.total }}</div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" md="6">
        <div class="d-flex align-center mb-4">
          <v-icon color="#1B2559" class="mr-2">mdi-medal</v-icon>
          <h3 class="text-h5 font-weight-black" style="color: #1B2559;">Miembros más Frecuentes</h3>
        </div>
        <v-row>
          <v-col v-for="(s, sIdx) in totalesMiembros" :key="sIdx" cols="12" sm="6">
            <v-card class="rounded-xl pa-4 elevation-1 d-flex align-center">
              <v-avatar size="40" class="mr-3">
                <img :src="s.imagen ? urlImagen(s.imagen) : 'https://cdn-icons-png.flaticon.com/512/149/149071.png'">
              </v-avatar>
              <div>
                <div class="caption grey--text font-weight-bold">{{ s.nombre }}</div>
                <div class="text-h6 font-weight-black" style="color: #05CD99;">{{ s.total }} Visitas</div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-overlay :value="cargando" color="#1B2559" opacity="0.8">
      <v-progress-circular indeterminate size="64" color="#4318FF"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import PeriodoBusqueda from '../Dialogos/PeriodoBusqueda.vue'

export default {
    components: { PeriodoBusqueda },
    data:()=>({
        busqueda: "", cargando: false, visitas: [],
        totalesMembresias: [], totalesUsuarios: [], totalesMiembros: [],
        filtros: { fechaInicio: null, fechaFin: null },
        encabezadoTabla: [
            {text: "Imagen", value: "imagen", sortable: false},
            {text: "Miembro", value: "nombre"},
            {text: "Matrícula", value: "matricula"},
            {text: "Fecha/Hora Entrada", value: "fecha"},
            {text: "Membresía", value: "membresia"},
            {text: "Registró", value: "usuario"},
        ],
    }),
    mounted() { this.obtenerVisitas(); },
    methods: {
        onBuscar(fechas) {
            this.filtros = { fechaInicio: fechas[0], fechaFin: fechas[1] };
            this.obtenerVisitas();
        },
        urlImagen(img) { return Utiles.generarURL(img, 'miembros'); },
        obtenerVisitas() {
            this.cargando = true;
            HttpService.obtenerConDatos({ metodo: 'obtener', filtros: this.filtros }, 'visitas.php')
            .then(res => {
                this.visitas = res.visitas || [];
                this.totalesMembresias = res.totalesMembresias || [];
                this.totalesUsuarios = res.totalesUsuarios || [];
                this.totalesMiembros = res.totalesMiembros || [];
                this.cargando = false;
            }).catch(() => { this.cargando = false; });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Visitas/Visitas.vue